module.exports = __webpack_public_path__ + "4a2d767a6659313ea800b529f1ab4ab0.svg";